import { useQuery } from "@tanstack/react-query";
import { getActiveRegions } from "../services/get-active-regions";
import { Region } from "../types/region";

export default function useActiveRegions() {
  return useQuery<Region[]>({
    queryKey: ["regions", "active"],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 30,
    queryFn: () => getActiveRegions(),
  });
}
